import { empresaDataInterface } from "../../pages/Empresa/empresa";

export const investData: empresaDataInterface = {
    "color": "rgba(77, 175, 88, 1)",
    "link": "/invest2030",
    "icon":"https://media.grupoinveste.pt/emp/invest2030/icon.png",
    "logo_white":"https://media.grupoinveste.pt/emp/invest2030/horizontal_white.png",
    "header": {
        "website": "https://invest2030.pt",
        "banner": "https://media.grupoinveste.pt/emp/invest2030/banner.png",
        "tags": [
            "invest2030.tags.0", "invest2030.tags.1", "invest2030.tags.2",
        ],
        "name": "invest2030.name",
        "slogan": "invest2030.slogan"
    },
    "section1": {
        "img": "https://media.grupoinveste.pt/emp/invest2030/horizontal_color.png",
        "title_1": "invest2030.section1.title1",
        "text_1": "invest2030.section1.text1",
        "text_2": "invest2030.section1.text2",
        "title_2": "invest2030.section1.title2",
        "text_3": "invest2030.section1.text3",
        "text_4": "invest2030.section1.text4",
    },
    "section2": [
        {
            "title": "invest2030.section2.0.title",
            "text": [
                "invest2030.section2.0.text.0", "invest2030.section2.0.text.1", "invest2030.section2.0.text.2"
            ]
        },
        {
            "title": "invest2030.section2.1.title",
            "text": [
                "invest2030.section2.1.text.0", "invest2030.section2.1.text.1"
            ]
        },
        {
            "title": "invest2030.section2.2.title",
            "text": [
                "invest2030.section2.2.text.0", "invest2030.section2.2.text.1", "invest2030.section2.2.text.2"
            ]
        },
        {
            "title": "invest2030.section2.3.title",
            "text": [
                "invest2030.section2.3.text.0", "invest2030.section2.3.text.1", "invest2030.section2.3.text.2", "invest2030.section2.3.text.3"
            ]
        },
        {
            "title": "invest2030.section2.4.title",
            "text": [
                "invest2030.section2.4.text.0", "invest2030.section2.4.text.1", "invest2030.section2.4.text.2", "invest2030.section2.4.text.3"
            ]
        }
    ],
    "section3": {
        "title": "invest2030.section3.title",
        "text": "invest2030.section3.text",
        "link": "https://www.invest2030.pt/meeting?aff=sitegrupoinveste"
    }
}